import * as React from 'react';
import { cn } from '../cn';

export const Label = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(function Label({ className, ...p }, ref) {
  // eslint-disable-next-line jsx-a11y/label-has-associated-control -- htmlFor arrives via props (Field wires it)
  return <label ref={ref} className={cn('block text-sm font-medium text-fg mb-1', className)} {...p} />;
});

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement> & { invalid?: boolean }>(function Input(
  { className, invalid, ...p },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'h-10 w-full rounded-md border border-border bg-surface px-3 text-sm text-fg placeholder:text-fg-muted focus-visible:outline-2 focus-visible:outline-focus disabled:opacity-50',
        invalid && 'border-danger',
        className,
      )}
      {...p}
    />
  );
});

/** Label + control + description/error with correct aria wiring. */
export function Field({ id, label, error, hint, children }: { id: string; label: React.ReactNode; error?: React.ReactNode; hint?: React.ReactNode; children: React.ReactElement }) {
  const describedBy = [hint ? `${id}-hint` : null, error ? `${id}-err` : null].filter(Boolean).join(' ') || undefined;
  return (
    <div className="mb-4">
      <Label htmlFor={id}>{label}</Label>
      {React.cloneElement(children as React.ReactElement<Record<string, unknown>>, { id, 'aria-describedby': describedBy, invalid: !!error })}
      {hint ? <p id={`${id}-hint`} className="mt-1 text-xs text-fg-muted">{hint}</p> : null}
      {error ? <p id={`${id}-err`} role="alert" className="mt-1 text-xs text-danger">{error}</p> : null}
    </div>
  );
}
